import React from 'react';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalBlockWrapper from './ModalBlockWrapper.jsx';

function ModalAsignarTutor(props) {
  return (
    <Modal show={props.showModal} onHide={props.onHideModal}>
      <ModalBlockWrapper
        content={
          <div>
            <Modal.Header closeButton>
              <Modal.Title><i className="fa fa-share-alt"></i>&nbsp;&nbsp;&nbsp;Asignar Proyectos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Seleccione uno o más usuarios</p>
              <Select
                placeholder="Seleccione un tutor"
                closeOnSelect={true}
                name="usersAssignSelect"
                value={props.selectValue}
                options={props.selectOptions}
                onChange={(value) => { props.selectOnChange(value)}}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button simple onClick={props.onClickCancel}>
                Cancelar
              </Button>
              <Button
                bsStyle="success" fill onClick={props.onClickAccept}
                disabled={props.acceptDisabled}
              >
                Asignar
              </Button>
            </Modal.Footer>
          </div>
        }
      />
    </Modal>
  );
}

export default ModalAsignarTutor;



// WEBPACK FOOTER //
// ./src/views/Components/ModalAsignarTutor.jsx